import DefinitionTooltip from '../DefinitionTooltip';
import { PlaceholderText } from '../Placeholders';
import { formatVolume } from 'utils/helpers';
import styled from 'styled-components';
import { tooltips } from '@/copy';

export const StatDisplay = ({
    isLoading,
    week,
    year,
    valueKey,
    tooltipKey,
    contentKey,
    labelPrefix,
    labelSuffix = '',
    ...props
}) => {
    const value = props[valueKey];
    const sourceAttributionProps = { week, year };

    return (
        valueKey in props && (
            <div>
                <Value>
                    {!value && isLoading ? (
                        <PlaceholderText />
                    ) : (
                        formatVolume(value)
                    )}
                    <DefinitionTooltip
                        {...tooltips[tooltipKey]}
                        {...sourceAttributionProps}
                        mixpanelMeta={{ contentKey }}
                        openOnClick={true}
                    />
                </Value>
                {/* eslint-disable-next-line jsx-a11y/label-has-for */}
                <Label>
                    {labelPrefix} {labelSuffix}
                </Label>
            </div>
        )
    );
};

const Value = styled.div`
    font-size: 1.25rem;
    font-weight: ${({ theme }) => theme.fontExtrabold};
    height: 2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-transform: uppercase;
`;

const Label = styled.div`
    font-size: 0.75rem;
    font-weight: ${({ theme }) => theme.fontBold};
    text-transform: uppercase;
    color: ${({ theme }) => theme.gray_700};
`;
